import React, { Suspense } from "react";
import { Route } from "react-router-dom";
import { RequireAuth } from "../../authorize/requireAuth";

const InvestmentReviewPage = React.lazy(() => import("./index"));

export const useInvestmentReviewRoutes = () => (
  <Route
    path="investmentReview"
    element={
      <RequireAuth policies={["InvestmentMonthlyPerformance-Update"]} redirect={true}>
        <Suspense fallback={<div>منتظر باشید...</div>}>
          <InvestmentReviewPage />
        </Suspense>
      </RequireAuth>
    }
  />
);
